const ITEMS = [
  "PLUGINS · ADDONS · ADMIN APPS",
  "FORGED WITH INTENT",
  "TERRITORIA — OPEN BETA 01.01.2027",
  "PROVEN IN PRODUCTION",
  "SMALL TEAM, BIG WORLDS",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="px-10 font-display text-xl font-semibold uppercase tracking-[0.2em] text-[#9EA4B0] sm:text-2xl">
          {item}
        </span>
        <span className="h-2 w-2 rotate-45 bg-[#E52E2E]" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-[#282D37] bg-[#0D0F12] py-5"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
